import { render, staticRenderFns } from "./quickBuy.vue?vue&type=template&id=0a2a4c0a"
import script from "./quickBuy.vue?vue&type=script&lang=js"
export * from "./quickBuy.vue?vue&type=script&lang=js"
import style0 from "./quickBuy.vue?vue&type=style&index=0&id=0a2a4c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports